import { count } from 'rxjs/operators';

const initialState = {
    count: undefined
};

function notificationsReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'NOTIFICAION_COUNT':
            if (action?.msg) {
                const uncheckedNotifications = action?.msg?.payload?.uncheckedNotifications;
                const uncheckedFutureNotifications = action?.msg?.payload?.uncheckedFutureNotifications;
                return {
                    ...state,
                    count: uncheckedNotifications + uncheckedFutureNotifications
                };
            }
            return {
                ...state,
                count: action?.count
            };
        case 'REDUCE_NOTIFICAION_COUNT':
            return {
                ...state,
                count: state.count - 1
            };
        default:
            return state;
    }
}

export default notificationsReducer;
